import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

export const fetchJourney = () => api.get("/healthcierge/current").then((r) => r.data);
export const fetchKatlasStatus = () => api.get("/katlas/status").then((r) => r.data);
export const approveReview = (body) =>
    api.post("/healthcierge/review/approve", body).then((r) => r.data);
export const refuseReview = (body) =>
    api.post("/healthcierge/review/refuse", body).then((r) => r.data);
export const fetchPublicReceipt = (hash) =>
    api.get(`/healthcierge/receipts/${encodeURIComponent(hash)}/public`).then((r) => r.data);
export const fetchExtensions = () =>
    api.get("/healthcierge/extensions").then((r) => r.data);
